import { RJLog } from "../../node/log/RJLog";

export class Request<I,O>
{
  _url:string;
  _method:string;

  constructor( url:string, method:"GET"|"POST" = "POST" )
  {
    this._url = url;
    this._method = method;
  }

  static get<O>( url:string ):Promise<O>
  {
    let request = new Request<any,O>( url, "GET" );

    try 
    {
      let result =  request.send( null );

      return Promise.resolve( result );
    }
    catch( e )
    {
      return Promise.resolve( null );
    }
  }

  static post<I,O>( url:string, input:I, dontParseResponse:boolean = false, logResponse = false ):Promise<O>
  {
    let request = new Request<I,O>( url, "POST" );

    try 
    {
      let result =  request.send( input, logResponse, dontParseResponse );

      return Promise.resolve( result );
    }
    catch( e )
    {
      return Promise.resolve( null );
    }
  }

  async send( input:I, logResponse:boolean = false, dontParseResponse:boolean = false ):Promise<O>
  {
    let promise = new Promise<O>(
      ( resolve, reject ) =>
      {  
        let requestURL = this._url;

        console.log( "Requesting:", this._url );

        let xhttp = new XMLHttpRequest();
        xhttp.open( this._method, requestURL, true );
        xhttp.setRequestHeader( "Content-Type", "application/json");

      
        

        xhttp.onerror = ( errorMessage )=>
        {
          console.warn( 
            "ERROR REQUESTING: ", 
            requestURL, input, ">>", 
            xhttp.status, xhttp.statusText 
          );
          console.error( errorMessage );
          reject();          
        }

        xhttp.onload = ()=>
        {
          if ( dontParseResponse )
          {
            console.log( xhttp.response );
            resolve( null );
            return;
          }

          try
          {
            let responseText = xhttp.responseText;
            
            if ( logResponse )
            { 
              console.log( "LOGGED RESPONSE: ", requestURL, input, "\n",`'${responseText}'` );
            }

            if ( /^\s*\{/.test( responseText ) )
            {
              let jsonObject = JSON.parse( responseText );

              resolve( jsonObject as O );
            }
            else
            {
              console.warn( "REJECTING RESPONSE: ", requestURL, responseText, input );
              reject();
            }
            
          }
          catch( e )
          {
            console.warn( "ERROR PROCESSING RESPONSE: ", requestURL );
            reject();
          }
          
        }

        if ( input )
        {          
          let sendingData = JSON.stringify( input );
          xhttp.send( sendingData );
        }
        else
        {
          xhttp.send();
        }
        

      }
    );

    return promise;
  }

  static async asPost<I,O>( url:string, i:I ):Promise<O>
  {
    let request = new Request<I,O>( url, "POST" );

    try
    {
      let result = await request.send( i );
      return Promise.resolve( result );
    }
    catch ( e )
    {
      return Promise.resolve( null );
    }
  }

}